import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';


let tooltip = ""
export function PageHeader({ title, path, buttonText, isButtonEnable, isChanged, clearPage }) {
    let className = "fas"
    const history = useHistory();

    if (title.includes("Add") || title.includes("Edit") || title.includes("Approval") 
        || title.includes("Change") || title.includes("View") || title.includes("Approve") || title.includes("Reset") || title == "Sync BPL Master Data" || title == "Transaction Sync") {
        className += " fa-arrow-left"
        tooltip += "Back"
    } else {
        className += " fa-plus"
        tooltip += "Add"
    }

    function onNavigateCheck() {
        if (isChanged !== undefined && isChanged > 2) {
            if (window.confirm("Do you want to go back?")) {
                history.push(path)
            } else {
                return
            }
        } else {
            history.push(path)
        }
    }

    function clearOnClick (){
        if(clearPage !== undefined){
            clearPage();
        }
    }

    return (
        <Fragment>
            <div className="card-header">
                <div className="row">
                    <div className="col-md-10">
                        <h5 className="title">{title}</h5>
                    </div>
                    {isButtonEnable ?
                        <div className="col-md-2">
                            <div className="form-group">
                                <Tooltip title={buttonText}>
                                    <button
                                        className="btn btn-info btn-md pull-right btn-nav"
                                        onClick={() => {
                                            onNavigateCheck(); 
                                            clearOnClick();
                                        }}>
                                        <i className={className}></i>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        </Fragment>
    );
}